import React from "react";
import Product from "./Product";
import Title from "./Title";
import { ProductConsumer } from "../context";

export default function ProductList() {
  return (
    <React.Fragment>
      <div className="pb-5 pt-4">
        <div className="container">
          <Title name="our" title="products" />
          {/* Product List */}
          <div className="row">
            <ProductConsumer>
              {({ products }) => {
                return products.map(product => {
                  return <Product key={product.id} product={product} />;
                });
              }}
            </ProductConsumer>
          </div>
        </div>
      </div>
      <Product />
    </React.Fragment>
  );
}
